import { NaturePeopleOutlined } from "@material-ui/icons"
import { useEffect, useState } from "react"
import { getAllService } from "../../api/requestAxios/accounting"
import constants from "../../constants/constants"
import { GetLineServiceText } from "../../functions"
import { ErrorToast, InfoToast } from "../../shared"

const OutputService = ({
    setOutputService
}) => {

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {

        getService()

    }, [])

    useEffect(() => {
        if (success) {
            InfoToast('لیست سرویس‌ها در حال دانلود می‌باشد')
        }

    }, [success])


    const getService = async () => {
        let failed = false
        try {
            setLoading(true)
            const services = await getAllService()
            if (services?.data?.Success !== undefined && !services?.data?.Success) {
                failed = true
                ErrorToast(services?.data?.Message)

            }
            else if (services.data) {
                var mediaType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
                var a = document.createElement('a');
                a.href = mediaType + services.data;
                a.download = `${Date.now()}.xlsx`;
                a.textContent = 'Download file!';
                document.body.appendChild(a);
                a.click()
                document.body.removeChild(a);
                setOutputService(false)
            }
            setLoading(false)

            // const url = window.URL.createObjectURL(new Blob([services.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', `${Date.now()}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // failed = false
            // setOutputService(false)
        }
        catch {
            setLoading(false)
            failed = true
            ErrorToast(constants.ServerErroe)
            setOutputService(false)
        }
        setSuccess(!failed)
    }

    return (
        null
    )
}
export default OutputService
